import { GlobalsService } from './globals.service';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { AlmaOidcService } from '@almaobservatory/alma-oidc-client';
import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { AccountService } from './account.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'account-editor';
  constructor(
    public globals: GlobalsService,
    public router: Router,
    private route: ActivatedRoute,
    private almaOidcService: AlmaOidcService,
    private accountService: AccountService,
  ) {}

  ngOnInit(): void {

    let searchParams: URLSearchParams;

    // Extract search parameters from the URL, we'll use them to support impersonation
    this.route.url.subscribe(() => {
      // searchParams = AlmaOidcService.extractSearchParameters();
      // # TODO AlmaOidcService.extractSearchParameters(); should work with Angular 16+.
      // is extractSearchParameters really necessary in this context?
      searchParams = new URLSearchParams(window.location.search);

      this.router.events.subscribe((event) => {
        if (event instanceof NavigationStart) {
          console.log(
            'this.router.navigated:',
            this.router.navigated,
            JSON.stringify(event)
          );
        }
      });

      const navigateTo =
        window.location.hash.length === 0
          ? '/raw-data-access'
          : window.location.hash.substring(1);

      this.almaOidcService
        .authenticateAndInit(environment.oauthOidcClientID, this.globals.resourceServerURL, undefined, searchParams)
        .then(idClaims => {
          this.globals.impersonated = false;
          if (idClaims.extraState) {
            this.globals.accountId = idClaims.extraState.user;
            this.globals.impersonated = !!this.globals.accountId
          } else if (searchParams != null) { // Workaround for alma-oidc-client not setting extraState when reloading the page
            for (const [key, value] of searchParams) {
              if (key === 'user') {
                this.globals.accountId = value;
                this.globals.impersonated = !!this.globals.accountId;
                this.accountService.getFullName(value)
                  .subscribe(fullName => this.globals.impersonatedName = fullName)
              }
            }
          }
        })
        .then(() => this.startup(this.almaOidcService.userIdentity))
        .then(() => this.router.navigateByUrl(navigateTo))
        .catch(reason => console.error(reason))
    });

  }

  startup( userIdentity: any ) {
    console.log('<<<<<<<<<<<<<<< location ' + location.href);

    if( !this.globals.accountId ) {
      // NO, take account ID from token
      this.globals.accountId = userIdentity['preferred_username'];
      console.log('<<<<<<<<<<<<<<< this.globals.accountId: ' + this.globals.accountId);
    }

    // All is well, we are logged in, let's save account info
    this.globals.account = {
      username: this.almaOidcService.username,
      fullName: this.almaOidcService.fullname,
      email: this.almaOidcService.email,
      roles: this.almaOidcService.roles
    };

    console.log("Account: " + JSON.stringify(this.globals.account));
  }
}
